var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "apartment-page",
      on: {
        mouseleave: function ($event) {
          return _vm.$root.showMascot($event)
        },
      },
    },
    [
      _vm.apartment
        ? _c(
            "div",
            { staticClass: "apartment-page__wrapper" },
            [
              _c(
                "page-header",
                {
                  staticClass: "apartment-page__header",
                  attrs: {
                    "dark-crumb": "",
                    inline: "",
                    title: _vm.apartmentName,
                    "link-to": { name: "FilterPage" },
                  },
                },
                [
                  false
                    ? _c(
                        "div",
                        { staticClass: "apartment-page__header-checks" },
                        [
                          _c(
                            "check-tag",
                            { staticClass: "apartment-page__header-check" },
                            [_vm._v(" Вид на дорогу ")]
                          ),
                          _c(
                            "check-tag",
                            { staticClass: "apartment-page__header-check" },
                            [_vm._v(" Потолки 3,3 м ")]
                          ),
                          _c(
                            "check-tag",
                            { staticClass: "apartment-page__header-check" },
                            [_vm._v(" Цена до 22.03 ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
              _c(
                "content-wrapper-block",
                { staticClass: "apartment-page__detail apart-detail" },
                [
                  _c(
                    "div",
                    { staticClass: "apart-detail__content" },
                    [
                      _c(
                        "ui-tab-bar",
                        {
                          staticClass: "apart-detail__tabs",
                          model: {
                            value: _vm.tabs.current,
                            callback: function ($$v) {
                              _vm.$set(_vm.tabs, "current", $$v)
                            },
                            expression: "tabs.current",
                          },
                        },
                        _vm._l(_vm.tabs.options, function (tab, index) {
                          return _c(
                            "ui-tab-bar-tab",
                            {
                              key: index,
                              staticClass: "apart-detail__tab",
                              attrs: { value: tab },
                            },
                            [_vm._v(" " + _vm._s(tab) + " ")]
                          )
                        }),
                        1
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.tabs.current === "Планировка",
                              expression: "tabs.current === 'Планировка'",
                            },
                          ],
                          staticClass: "apart-detail__tab-content",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "apart-detail__plan" },
                            [
                              _c(
                                "picture",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.layoutSelected === 0,
                                      expression: "layoutSelected === 0",
                                    },
                                  ],
                                  key: -1,
                                },
                                [
                                  _c("source", {
                                    attrs: {
                                      srcset:
                                        _vm.apartment.layout.plan_image.source,
                                      media: "(min-width: 1200px)",
                                    },
                                  }),
                                  _c("img", {
                                    staticClass: "apart-detail__plan-image",
                                    attrs: {
                                      src: _vm.apartment.layout.plan_image
                                        .image_thumb,
                                    },
                                  }),
                                ]
                              ),
                              _vm._l(_vm.alternative, function (plan, index) {
                                return _c(
                                  "picture",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.layoutSelected === index + 1,
                                        expression:
                                          "layoutSelected === index + 1",
                                      },
                                    ],
                                    key: index,
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "apart-detail__plan-image",
                                      attrs: { src: plan.image.image_desktop },
                                    }),
                                  ]
                                )
                              }),
                              _vm.apartment.discount &&
                              _vm.apartment.properties?.give_meters
                                ? _c(
                                    "div",
                                    { staticClass: "apart-detail__plan-promo" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.helpers.getDiscountArea(
                                              _vm.apartment
                                            )
                                          ) +
                                          " м² "
                                      ),
                                      _c("small", [_vm._v("в подарок!")]),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "ui-button-small",
                                {
                                  staticClass: "apart-detail__fullscreen",
                                  on: { click: _vm.showModal },
                                },
                                [_c("icon-fullscreen")],
                                1
                              ),
                            ],
                            2
                          ),
                          _vm.alternative
                            ? _c(
                                "div",
                                { staticClass: "apart-detail__title" },
                                [
                                  _c("img", {
                                    staticClass: "apart-container__type-icon",
                                    attrs: {
                                      src: require("@/assets/images/icons/plans.svg"),
                                    },
                                  }),
                                  _vm._v(" Возможные планировки "),
                                ]
                              )
                            : _vm._e(),
                          _vm.alternative
                            ? _c(
                                "div",
                                { staticClass: "apart-detail__alternative" },
                                [
                                  _c("card-apartment-plan", {
                                    staticClass:
                                      "apart-detail__alternative-item",
                                    attrs: {
                                      selected: _vm.layoutSelected === 0,
                                      "image-jpg": _vm.getPlanImage(
                                        _vm.apartment,
                                        "png"
                                      ),
                                      subtitle: "Основная",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.layoutSelected = 0
                                      },
                                    },
                                  }),
                                  _vm._l(
                                    _vm.alternative,
                                    function (plan, index) {
                                      return _c("card-apartment-plan", {
                                        key: index,
                                        staticClass:
                                          "apart-detail__alternative-item",
                                        attrs: {
                                          selected:
                                            index + 1 === _vm.layoutSelected,
                                          "image-jpg": plan.image.image_thumb,
                                          subtitle:
                                            "Возможность " + (index + 1),
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.layoutSelected = index + 1
                                          },
                                        },
                                      })
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.tabs.current === "Этаж",
                              expression: "tabs.current === 'Этаж'",
                            },
                          ],
                          staticClass: "apart-detail__tab-content-dls",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "apart-detail__plan-poligon" },
                            [
                              _c(
                                "street-compass-wrapper",
                                { attrs: { korpus: _vm.apartment.korpus } },
                                [
                                  _c("floor-plan-zoom-poligon", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.apartment.floor_image.image_thumb,
                                        expression:
                                          "apartment.floor_image.image_thumb",
                                      },
                                    ],
                                    attrs: {
                                      zoom: false,
                                      src: _vm.apartment.floor_image
                                        .image_thumb,
                                      polygons: _vm.polygons,
                                      width: _vm.apartment.floor_image.width,
                                      height: _vm.apartment.floor_image.height,
                                    },
                                    on: { polygonClick: _vm.onPolygonClick },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "ui-button-small",
                                {
                                  staticClass: "apart-detail__fullscreen",
                                  on: { click: _vm.showModal },
                                },
                                [_c("icon-fullscreen")],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.tabs.current === "Генплан",
                              expression: "tabs.current === 'Генплан'",
                            },
                          ],
                          staticClass: "apart-detail__tab-content-dls",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "apart-detail__plan-poligon" },
                            [
                              _vm.apartment.section
                                ? _c("gen-plan", {
                                    attrs: { section: _vm.apartment.section },
                                  })
                                : _vm._e(),
                              _c(
                                "ui-button-small",
                                {
                                  staticClass: "apart-detail__fullscreen",
                                  on: { click: _vm.showModal },
                                },
                                [_c("icon-fullscreen")],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm.apartment.properties._gallery
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.tabs.current === "Фотографии отделки",
                                  expression:
                                    "tabs.current === 'Фотографии отделки'",
                                },
                              ],
                              staticClass: "apart-detail__tab-content",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "apart-detail__gallery" },
                                [
                                  _c("apartment-gallery", {
                                    attrs: {
                                      slides: _vm.apartment.properties._gallery,
                                      "gallery-title": "Все фотографии",
                                      showNav: "",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "apart-detail__info apart-info" }, [
                    _c("div", { staticClass: "apart-info__areas" }, [
                      _c("div", { staticClass: "apart-info__areas-title" }, [
                        _vm._v(
                          " ПЛОЩАДЬ ПОМЕЩЕНИЙ, " + _vm._s(_vm.area) + " М² "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "apart-info__areas-list apart-areas" },
                        [
                          _c(
                            "ol",
                            { staticClass: "apart-areas__list" },
                            [
                              _vm._l(
                                _vm.roomItems,
                                function (roomarea, areaindex) {
                                  return _c(
                                    "li",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.apartment.areas,
                                          expression: "apartment.areas",
                                        },
                                      ],
                                      key: areaindex,
                                      staticClass:
                                        "apart-areas__list-item area-item",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "area-item__number" },
                                        [_vm._v(_vm._s(roomarea.number))]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "area-item__body" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "area-item__key" },
                                            [_vm._v(_vm._s(roomarea.name))]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "area-item__value" },
                                            [
                                              _vm._v(
                                                _vm._s(roomarea.area) + " м²"
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              _vm.page < _vm.numPages
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "items__shown",
                                      on: {
                                        click: function ($event) {
                                          return _vm.next(+1)
                                        },
                                      },
                                    },
                                    [_vm._v("Показать все")]
                                  )
                                : _vm._e(),
                              _vm.page >= _vm.numPages
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "items__shown",
                                      on: {
                                        click: function ($event) {
                                          return _vm.next(-1)
                                        },
                                      },
                                    },
                                    [_vm._v("Cкрыть")]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                      _vm.alternative
                        ? _c(
                            "div",
                            { staticClass: "apart-detail__description" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "apart-detail__description-top",
                                },
                                [
                                  _c("div", {}, [
                                    _vm._v(" особенности планировки | "),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.apartment.plan_type)),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "items" }, [
                                    _vm.shownBtn
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "items__shown",
                                            on: { click: _vm.clickShown },
                                          },
                                          [_vm._v("Узнать")]
                                        )
                                      : _vm._e(),
                                    _vm.closeBtn
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "items__shown",
                                            on: { click: _vm.clickClose },
                                          },
                                          [_vm._v("Cкрыть")]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                              _vm.descr
                                ? _c(
                                    "div",
                                    {},
                                    _vm._l(
                                      _vm.description,
                                      function (desc, index) {
                                        return _c("div", {
                                          key: index,
                                          staticClass:
                                            "apart-detail__description-items",
                                          domProps: { innerHTML: _vm._s(desc) },
                                        })
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "apart-info__props apart-props",
                        staticStyle: { padding: "0", "border-bottom": "none" },
                      },
                      [
                        _vm.hasDecoration
                          ? _c("div", { staticClass: "apart-props__item" }, [
                              _c(
                                "div",
                                { staticClass: "apart-props__item-label" },
                                [
                                  _c("img", {
                                    staticClass: "apart-props__item-icon",
                                    attrs: {
                                      src: require("@/assets/images/icons/decoration_dark.svg"),
                                      alt: "",
                                    },
                                  }),
                                  _vm._v("Отделка "),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "apart-props__item-value" },
                                [
                                  _vm.apartment.properties
                                    .with_decoration_furnished
                                    ? [
                                        _vm._v(" С отделкой"),
                                        _c("br"),
                                        _vm._v("и мебелью** "),
                                      ]
                                    : _vm.apartment.properties
                                        .with_decoration_finishing
                                    ? [_vm._v(" Чистовая ")]
                                    : _vm.apartment.properties
                                        .with_decoration_design
                                    ? [_vm._v(" Дизайнерская ")]
                                    : _vm.apartment.properties
                                        .with_decoration_whitebox
                                    ? [_vm._v(" Предчистовая отделка ")]
                                    : [
                                        _vm._v(" На выбор "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "apart-props__item-value--small",
                                          },
                                          [
                                            _c("span", [_vm._v("x")]),
                                            _vm._v("4 варианта "),
                                          ]
                                        ),
                                      ],
                                ],
                                2
                              ),
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "apart-props__item" }, [
                          _c(
                            "div",
                            { staticClass: "apart-props__item-label" },
                            [_vm._v("Секция")]
                          ),
                          _c(
                            "div",
                            { staticClass: "apart-props__item-value" },
                            [_vm._v(" " + _vm._s(_vm.apartment.section) + " ")]
                          ),
                        ]),
                        _c("div", { staticClass: "apart-props__item" }, [
                          _c(
                            "div",
                            { staticClass: "apart-props__item-label" },
                            [_vm._v("Этаж")]
                          ),
                          _c(
                            "div",
                            { staticClass: "apart-props__item-value" },
                            [_vm._v(" " + _vm._s(_vm.apartment.floor) + " ")]
                          ),
                        ]),
                        _c("div", { staticClass: "apart-props__item" }, [
                          _c(
                            "div",
                            { staticClass: "apart-props__item-label" },
                            [_vm._v("№ на площадке")]
                          ),
                          _c(
                            "div",
                            { staticClass: "apart-props__item-value" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.apartment.number_on_floor) +
                                  " "
                              ),
                            ]
                          ),
                        ]),
                        !_vm.hasDecoration
                          ? _c("div", { staticClass: "apart-props__item" }, [
                              _c(
                                "div",
                                { staticClass: "apart-props__item-label" },
                                [_vm._v("№ апартамента: ")]
                              ),
                              _c(
                                "div",
                                { staticClass: "apart-props__item-value" },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.apartment.number) + " "
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    _c("div", { staticClass: "apart-info__border" }),
                    _c("div", { staticClass: "apart-info__cost" }, [
                      _c(
                        "div",
                        { staticClass: "apart-info__cost-wrapper" },
                        [
                          _c(
                            "span",
                            { staticClass: "apart-info__cost-now_min" },
                            [
                              _vm._v(
                                _vm._s(
                                  parseInt(
                                    _vm.apartment.discount
                                      ? _vm.apartment.discount_cost
                                      : _vm.apartment.amount
                                  ).toLocaleString("ru")
                                ) + " ₽"
                              ),
                            ]
                          ),
                          _vm.apartment.discount ||
                          _vm.apartment.properties.old_cost
                            ? _c(
                                "span",
                                { staticClass: "apart-info__cost-old" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        parseInt(
                                          _vm.apartment.properties.old_cost ||
                                            _vm.apartment.amount
                                        ).toLocaleString("ru")
                                      ) +
                                      " ₽ "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.apartment.properties.cost_footnote
                            ? [_vm._v("**")]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm.storage.mortgage &&
                      _vm.apartment.status !== "Уступка от физлица"
                        ? _c("span", { staticClass: "apart-info__cost-now" }, [
                            _vm._v(
                              "или от " +
                                _vm._s(
                                  _vm.setMortgagePay(
                                    {
                                      ..._vm.apartment,
                                      cost:
                                        _vm.apartment.cost ??
                                        _vm.apartment.amount,
                                    },
                                    _vm.storage.mortgage
                                  )
                                ) +
                                " ₽/мес"
                            ),
                            _vm.storage.mortgage.footnote
                              ? _c(
                                  "b",
                                  { staticStyle: { "font-weight": "300" } },
                                  [_vm._v("*")]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      _vm.apartment.properties.mortgage_percent
                        ? _c(
                            "span",
                            { staticClass: "apart-info__special-mortgage" },
                            [
                              _vm._v(
                                " Особенные условия по ипотеке - минус " +
                                  _vm._s(
                                    _vm.apartment.properties.mortgage_percent
                                  ) +
                                  "% "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "apart-info__bottom",
                        class: {
                          "apart-info__bottom--column":
                            _vm.apartment.status === "Уступка от физлица",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "apart-info__bottom-buttons" },
                          [
                            _vm.apartment.status === "Свободен"
                              ? _c(
                                  "ui-button",
                                  {
                                    staticClass: "apart-info__bottom-act1",
                                    attrs: {
                                      id: "button-apartment__booking",
                                      "data-popup-with-chats": "",
                                      "data-popup-with-chats-title":
                                        "Узнать подробнее про №" +
                                        _vm.apartment.number,
                                    },
                                  },
                                  [_vm._v(" Узнать подробнее ")]
                                )
                              : _vm._e(),
                            _vm.apartment.status === "Свободен"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "apart-info__bottom-button-group apart-info__bottom-button-group--tradein",
                                  },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "ui-button",
                                          {
                                            staticClass:
                                              "apart-info__bottom-act2",
                                            attrs: {
                                              "data-popup-with-chats": "",
                                              "data-popup-with-chats-title":
                                                "Trade In",
                                              outline: "",
                                            },
                                          },
                                          [_vm._v(" Trade-In ")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "apart-info__bottom-share",
                                      },
                                      [
                                        _c(
                                          "ui-button",
                                          {
                                            staticClass:
                                              "apart-info__bottom-share-act2",
                                            attrs: { outline: "" },
                                            on: { click: _vm.openShare },
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                  width: "19",
                                                  height: "20",
                                                  viewBox: "0 0 19 20",
                                                  fill: "none",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M15.175 20C14.3917 20 13.7208 19.7208 13.1625 19.1625C12.6042 18.6042 12.325 17.9333 12.325 17.15C12.325 17.0333 12.3375 16.8958 12.3625 16.7375C12.3875 16.5792 12.425 16.4333 12.475 16.3L4.9 11.9C4.65 12.1833 4.34167 12.4125 3.975 12.5875C3.60833 12.7625 3.23333 12.85 2.85 12.85C2.06667 12.85 1.39583 12.5708 0.8375 12.0125C0.279167 11.4542 0 10.7833 0 10C0 9.2 0.279167 8.525 0.8375 7.975C1.39583 7.425 2.06667 7.15 2.85 7.15C3.23333 7.15 3.6 7.225 3.95 7.375C4.3 7.525 4.61667 7.74167 4.9 8.025L12.475 3.675C12.425 3.55833 12.3875 3.425 12.3625 3.275C12.3375 3.125 12.325 2.98333 12.325 2.85C12.325 2.05 12.6042 1.375 13.1625 0.825C13.7208 0.275 14.3917 0 15.175 0C15.975 0 16.65 0.275 17.2 0.825C17.75 1.375 18.025 2.05 18.025 2.85C18.025 3.63333 17.75 4.30417 17.2 4.8625C16.65 5.42083 15.975 5.7 15.175 5.7C14.7917 5.7 14.4208 5.6375 14.0625 5.5125C13.7042 5.3875 13.4 5.18333 13.15 4.9L5.575 9.1C5.60833 9.23333 5.6375 9.3875 5.6625 9.5625C5.6875 9.7375 5.7 9.88333 5.7 10C5.7 10.1167 5.6875 10.2417 5.6625 10.375C5.6375 10.5083 5.60833 10.6417 5.575 10.775L13.15 15.075C13.4 14.8417 13.6917 14.6542 14.025 14.5125C14.3583 14.3708 14.7417 14.3 15.175 14.3C15.975 14.3 16.65 14.575 17.2 15.125C17.75 15.675 18.025 16.35 18.025 17.15C18.025 17.9333 17.75 18.6042 17.2 19.1625C16.65 19.7208 15.975 20 15.175 20ZM15.175 4.2C15.5583 4.2 15.8792 4.07083 16.1375 3.8125C16.3958 3.55417 16.525 3.23333 16.525 2.85C16.525 2.46667 16.3958 2.14583 16.1375 1.8875C15.8792 1.62917 15.5583 1.5 15.175 1.5C14.7917 1.5 14.4708 1.62917 14.2125 1.8875C13.9542 2.14583 13.825 2.46667 13.825 2.85C13.825 3.23333 13.9542 3.55417 14.2125 3.8125C14.4708 4.07083 14.7917 4.2 15.175 4.2V4.2ZM2.85 11.35C3.23333 11.35 3.55417 11.2208 3.8125 10.9625C4.07083 10.7042 4.2 10.3833 4.2 10C4.2 9.61667 4.07083 9.29583 3.8125 9.0375C3.55417 8.77917 3.23333 8.65 2.85 8.65C2.46667 8.65 2.14583 8.77917 1.8875 9.0375C1.62917 9.29583 1.5 9.61667 1.5 10C1.5 10.3833 1.62917 10.7042 1.8875 10.9625C2.14583 11.2208 2.46667 11.35 2.85 11.35V11.35ZM15.175 18.5C15.5583 18.5 15.8792 18.3708 16.1375 18.1125C16.3958 17.8542 16.525 17.5333 16.525 17.15C16.525 16.7667 16.3958 16.4458 16.1375 16.1875C15.8792 15.9292 15.5583 15.8 15.175 15.8C14.7917 15.8 14.4708 15.9292 14.2125 16.1875C13.9542 16.4458 13.825 16.7667 13.825 17.15C13.825 17.5333 13.9542 17.8542 14.2125 18.1125C14.4708 18.3708 14.7917 18.5 15.175 18.5Z",
                                                    fill: "#E14313",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("div", {
                                          staticClass:
                                            "apart-info__bottom-share-container",
                                          class: { openned: _vm.shareOpenned },
                                          attrs: { id: "yaShare" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.apartment.status === "Забронировано"
                              ? _c(
                                  "div",
                                  { staticClass: "apart-info__bottom-booked" },
                                  [_vm._v(" апартамент уже забронирован ")]
                                )
                              : _vm._e(),
                            _vm.apartment.status === "Уступка от физлица"
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "apart-info__bottom-booked",
                                    },
                                    [_vm._v("Уступка от физлица")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "apart-info__bottom-button-group",
                                    },
                                    [
                                      _c(
                                        "ui-button",
                                        {
                                          staticClass:
                                            "apart-info__bottom-act2",
                                          attrs: {
                                            outline: "",
                                            "data-popup-with-chats": "",
                                            "data-popup-with-chats-title":
                                              "Консультация",
                                          },
                                        },
                                        [_vm._v(" Консультация ")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "apart-info__bottom-share",
                                        },
                                        [
                                          _c(
                                            "ui-button",
                                            {
                                              staticClass:
                                                "apart-info__bottom-share-act2",
                                              attrs: { outline: "" },
                                              on: { click: _vm.openShare },
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    width: "19",
                                                    height: "20",
                                                    viewBox: "0 0 19 20",
                                                    fill: "none",
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      d: "M15.175 20C14.3917 20 13.7208 19.7208 13.1625 19.1625C12.6042 18.6042 12.325 17.9333 12.325 17.15C12.325 17.0333 12.3375 16.8958 12.3625 16.7375C12.3875 16.5792 12.425 16.4333 12.475 16.3L4.9 11.9C4.65 12.1833 4.34167 12.4125 3.975 12.5875C3.60833 12.7625 3.23333 12.85 2.85 12.85C2.06667 12.85 1.39583 12.5708 0.8375 12.0125C0.279167 11.4542 0 10.7833 0 10C0 9.2 0.279167 8.525 0.8375 7.975C1.39583 7.425 2.06667 7.15 2.85 7.15C3.23333 7.15 3.6 7.225 3.95 7.375C4.3 7.525 4.61667 7.74167 4.9 8.025L12.475 3.675C12.425 3.55833 12.3875 3.425 12.3625 3.275C12.3375 3.125 12.325 2.98333 12.325 2.85C12.325 2.05 12.6042 1.375 13.1625 0.825C13.7208 0.275 14.3917 0 15.175 0C15.975 0 16.65 0.275 17.2 0.825C17.75 1.375 18.025 2.05 18.025 2.85C18.025 3.63333 17.75 4.30417 17.2 4.8625C16.65 5.42083 15.975 5.7 15.175 5.7C14.7917 5.7 14.4208 5.6375 14.0625 5.5125C13.7042 5.3875 13.4 5.18333 13.15 4.9L5.575 9.1C5.60833 9.23333 5.6375 9.3875 5.6625 9.5625C5.6875 9.7375 5.7 9.88333 5.7 10C5.7 10.1167 5.6875 10.2417 5.6625 10.375C5.6375 10.5083 5.60833 10.6417 5.575 10.775L13.15 15.075C13.4 14.8417 13.6917 14.6542 14.025 14.5125C14.3583 14.3708 14.7417 14.3 15.175 14.3C15.975 14.3 16.65 14.575 17.2 15.125C17.75 15.675 18.025 16.35 18.025 17.15C18.025 17.9333 17.75 18.6042 17.2 19.1625C16.65 19.7208 15.975 20 15.175 20ZM15.175 4.2C15.5583 4.2 15.8792 4.07083 16.1375 3.8125C16.3958 3.55417 16.525 3.23333 16.525 2.85C16.525 2.46667 16.3958 2.14583 16.1375 1.8875C15.8792 1.62917 15.5583 1.5 15.175 1.5C14.7917 1.5 14.4708 1.62917 14.2125 1.8875C13.9542 2.14583 13.825 2.46667 13.825 2.85C13.825 3.23333 13.9542 3.55417 14.2125 3.8125C14.4708 4.07083 14.7917 4.2 15.175 4.2V4.2ZM2.85 11.35C3.23333 11.35 3.55417 11.2208 3.8125 10.9625C4.07083 10.7042 4.2 10.3833 4.2 10C4.2 9.61667 4.07083 9.29583 3.8125 9.0375C3.55417 8.77917 3.23333 8.65 2.85 8.65C2.46667 8.65 2.14583 8.77917 1.8875 9.0375C1.62917 9.29583 1.5 9.61667 1.5 10C1.5 10.3833 1.62917 10.7042 1.8875 10.9625C2.14583 11.2208 2.46667 11.35 2.85 11.35V11.35ZM15.175 18.5C15.5583 18.5 15.8792 18.3708 16.1375 18.1125C16.3958 17.8542 16.525 17.5333 16.525 17.15C16.525 16.7667 16.3958 16.4458 16.1375 16.1875C15.8792 15.9292 15.5583 15.8 15.175 15.8C14.7917 15.8 14.4708 15.9292 14.2125 16.1875C13.9542 16.4458 13.825 16.7667 13.825 17.15C13.825 17.5333 13.9542 17.8542 14.2125 18.1125C14.4708 18.3708 14.7917 18.5 15.175 18.5Z",
                                                      fill: "#E14313",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c("div", {
                                            staticClass:
                                              "apart-info__bottom-share-container",
                                            class: {
                                              openned: _vm.shareOpenned,
                                            },
                                            attrs: { id: "yaShare" },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        false
                          ? _c(
                              "div",
                              { staticClass: "apart-info__bottom-action" },
                              [
                                _c("ui-button-gray", [_c("icon-star")], 1),
                                _c("ui-button-gray", [_c("icon-printer")], 1),
                                _c("ui-button-gray", [_c("icon-share")], 1),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                    _c("div", { staticClass: "apart-info__border" }),
                    _vm.apartment.status !== "Уступка от физлица"
                      ? _c(
                          "span",
                          { staticClass: "apart-info__description" },
                          [
                            _c("p", {
                              staticClass: "apart-info__footnote",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.storage.mortgage.footnote
                                ),
                              },
                            }),
                            _vm.apartment.properties.with_decoration_furnished
                              ? [
                                  _c("br"),
                                  _vm._v(
                                    " **Декор и часть мебели не входят в стоимость апартаментов "
                                  ),
                                ]
                              : _vm._e(),
                            _vm.apartment.properties.has_decoration
                              ? [
                                  _c("br"),
                                  _vm._v(" ** Отделка включена в стоимость "),
                                ]
                              : _vm._e(),
                            _vm.apartment.properties.cost_footnote
                              ? _c("p", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.apartment.properties.cost_footnote
                                    ),
                                  },
                                })
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm.gallerySlides[_vm.apartment.id]
                ? _c("FlatGallery", {
                    attrs: { slides: _vm.gallerySlides[_vm.apartment.id] },
                  })
                : _vm._e(),
              false
                ? _c("callback-block", {
                    attrs: {
                      theme: "black",
                      title: "Ваш дизайн-проект - в подарок!",
                      subtitle: "При покупке до 20.07.2020",
                      image: require("../assets/images/forms/form-block-right.png"),
                    },
                  })
                : _vm._e(),
              _vm.apartment.status !== "Уступка от физлица"
                ? _c("mortgage-block")
                : _vm._e(),
              false ? _c("specials-block") : _vm._e(),
              _c("best-apartments-block"),
              _c("contacts-block", {
                attrs: {
                  "building-address": _vm.address,
                  "ofiice-address": _vm.office,
                  "building-work-time":
                    "<p>Пн-Пт с 09:00 до 21:00 <br> Сб-Вс с 10:00 до 20:00</p>",
                  "office-work-time":
                    "<p>Пн-Пт с 09:00 до 21:00 <br> Сб-Вс с 10:00 до 20:00</p>",
                },
              }),
              _c("callback-block", {
                attrs: {
                  id: "callback",
                  "id-formblock": "question-block__callback",
                },
              }),
              _c("modal-plans", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isModalVisible,
                    expression: "isModalVisible",
                  },
                ],
                ref: "test",
                attrs: {
                  apartment: _vm.apartment,
                  "apartment-number": _vm.apartment.number,
                  "slide-index": _vm.layoutSelected,
                  visible: _vm.visible,
                  alternative: _vm.alternative,
                  "layout-selected": _vm.layoutSelected,
                  src: _vm.imgSwitch,
                  "dls-plans": _vm.dlsSwitch,
                  title: _vm.titleSwitch,
                  polygons: _vm.polygons,
                },
                on: { polygonClick: _vm.onPolygonClick, close: _vm.closeModal },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }